// tslint:disable
// This file is generated by buildArtConfig script.
// Please don't edit it manually.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { artConfigBuildingsOverrides } from "./artConfigBuildingsOverrides";
import { IdAssetBundleBuildingsInitial } from "./IdAssetBundleBuildingsInitial";
import { IdAssetBundleBuildings } from "./IdAssetBundleBuildings";
export var TypeCollider;
(function (TypeCollider) {
    TypeCollider[TypeCollider["Box"] = 0] = "Box";
    TypeCollider[TypeCollider["Circle"] = 1] = "Circle";
    TypeCollider[TypeCollider["Polygon"] = 2] = "Polygon";
})(TypeCollider || (TypeCollider = {}));
export var artConfigBuildings = __assign({ acre1: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.acre_1,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-194, -28], [59, 96], [217, 13], [-31, -108]],
            },
        ],
    }, acre2: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_2,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[44, 90], [204, 9], [-23, -107], [-185, -26]],
            },
        ],
    }, acre3: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_3,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[53, 102], [221, 13], [-33, -117], [-200, -29]],
            },
        ],
    }, acre4: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_4,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, acre5: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_5,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[56, 96], [220, 14], [-33, -113], [-206, -27]],
            },
        ],
    }, acre6: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_6,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, acre7: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_7,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, acre8: {
        assets: [
            {
                id: IdAssetBundleBuildings.acre_8,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, almondOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_1,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, almondOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_2,
                offset: [-49, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, almondOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_3,
                offset: [-50, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 113], [217, 24], [121, -39], [4, -101], [-30, -98], [-206, -11]],
            },
        ],
    }, almondOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_4,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, almondOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_5,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, almondOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_6,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, almondOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_7,
                offset: [-44, -125],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, -10],
                radius: 118,
            },
        ],
    }, almondOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.almondOrchard_8,
                offset: [-43, -126],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [3, -9],
                radius: 118,
            },
        ],
    }, amazonDragonStatue1: {
        assets: [
            {
                id: IdAssetBundleBuildings.amazonDragonStatue_1,
                offset: [-5, -158],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[12, 116], [121, 48], [5, -154], [-101, 65]],
            },
        ],
    }, andromedaObservatory1: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_1,
                offset: [-6, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 116], [155, 42], [9, -63], [-151, 38]],
            },
        ],
    }, andromedaObservatory2: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_2,
                offset: [-8, -114],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 116], [155, 42], [8, -69], [-151, 38]],
            },
        ],
    }, andromedaObservatory3: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_3,
                offset: [-3, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 125], [146, 53], [4, -62], [-142, 49]],
            },
        ],
    }, andromedaObservatory4: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_4,
                offset: [-6, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 138], [161, 61], [6, -48], [-143, 65]],
            },
        ],
    }, andromedaObservatory5: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_5,
                offset: [-7, -149],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 150], [143, 80], [5, -71], [-128, 82]],
            },
        ],
    }, andromedaObservatory6: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_6,
                offset: [-5, -158],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 159], [122, 100], [11, -73], [-133, 91]],
            },
        ],
    }, andromedaObservatory7: {
        assets: [
            {
                id: IdAssetBundleBuildings.andromedaObservatory_7,
                offset: [-5, -158],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 161], [122, 101], [6, -71], [-137, 86]],
            },
        ],
    }, animalChessboard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalChessboard_1,
                offset: [-2, -76],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, animalChessboard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalChessboard_2,
                offset: [3, -86],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-4, 87], [162, 3], [-6, -82], [-165, 6]],
            },
        ],
    }, animalChessboard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalChessboard_3,
                offset: [0, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 84], [163, 2], [0, -79], [-165, 2]],
            },
        ],
    }, animalSoccer1: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_1,
                offset: [-3, -88],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer2: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_2,
                offset: [-3, -88],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer3: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_3,
                offset: [-3, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer4: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_4,
                offset: [-5, -90],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer5: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_5,
                offset: [-6, -94],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer6: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_6,
                offset: [-6, -101],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, animalSoccer7: {
        assets: [
            {
                id: IdAssetBundleBuildings.animalSoccer_7,
                offset: [-5, -100],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, appleOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_1,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, appleOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_2,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-192, -21], [46, 98], [217, 13], [-23, -107]],
            },
        ],
    }, appleOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_3,
                offset: [-49, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, appleOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_4,
                offset: [-50, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 113], [217, 24], [121, -39], [4, -101], [-30, -98], [-206, -11]],
            },
        ],
    }, appleOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_5,
                offset: [-49, -103],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[37, 109], [218, 19], [124, -48], [2, -106], [-45, -111], [-225, -19]],
            },
        ],
    }, appleOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_6,
                offset: [-49, -120],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-223, -3],
                    [37, 126],
                    [215, 36],
                    [142, -11],
                    [137, -47],
                    [-5, -110],
                    [-38, -90],
                ],
            },
        ],
    }, appleOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_7,
                offset: [-42, -140],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [5, -11],
                radius: 127,
            },
        ],
    }, appleOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.appleOrchard_8,
                offset: [-42, -141],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [4, -15],
                radius: 127,
            },
        ],
    }, asianArchway1: {
        assets: [
            {
                id: IdAssetBundleBuildings.asianArchway_1,
                offset: [-3, -66],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[8, 84], [76, 38], [60, -35], [-47, -85], [-75, 35]],
            },
        ],
    }, barn1: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.barn_1,
                offset: [-56, -98],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [58, 98],
                    [198, 25],
                    [88, -49],
                    [85, -85],
                    [13, -121],
                    [-40, -92],
                    [-179, -19],
                ],
            },
        ],
    }, barn2: {
        assets: [
            {
                id: IdAssetBundleBuildings.barn_2,
                offset: [-56, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[56, 109], [206, 35], [87, -26], [87, -79], [-22, -131], [-191, -14]],
            },
        ],
    }, barn3: {
        assets: [
            {
                id: IdAssetBundleBuildings.barn_3,
                offset: [-56, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[56, 116], [209, 40], [110, -12], [114, -75], [-20, -134], [-179, -1]],
            },
        ],
    }, barn4: {
        assets: [
            {
                id: IdAssetBundleBuildings.barn_4,
                offset: [-57, -115],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [39, 124],
                    [215, 36],
                    [143, -2],
                    [143, -57],
                    [-18, -133],
                    [-107, -60],
                    [-207, 0],
                ],
            },
        ],
    }, barn5: {
        assets: [
            {
                id: IdAssetBundleBuildings.barn_5,
                offset: [-58, -116],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[46, 122], [223, 32], [142, -12], [140, -62], [-28, -134], [-184, 8]],
            },
        ],
    }, beehive1: {
        assets: [
            {
                id: IdAssetBundleBuildings.beehive_1,
                offset: [-53, -57],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[53, 68], [140, 24], [56, -20], [14, -55], [-44, -70], [-130, -26]],
            },
        ],
    }, beehive2: {
        assets: [
            {
                id: IdAssetBundleBuildings.beehive_2,
                offset: [-55, -56],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[50, 65], [137, 20], [99, 1], [96, -32], [-47, -70], [-132, -24]],
            },
        ],
    }, beehive3: {
        assets: [
            {
                id: IdAssetBundleBuildings.beehive_3,
                offset: [-55, -66],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[51, 72], [134, 29], [99, 10], [96, -22], [-13, -78], [-126, -17]],
            },
        ],
    }, beehive4: {
        assets: [
            {
                id: IdAssetBundleBuildings.beehive_4,
                offset: [-53, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [51, 90],
                    [133, 43],
                    [100, 26],
                    [73, -11],
                    [97, -36],
                    [-27, -92],
                    [-29, -54],
                    [-124, -1],
                ],
            },
        ],
    }, birdbath1: {
        assets: [
            {
                id: IdAssetBundleBuildings.birdbath_1,
                offset: [-2, -107],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, birdbath2: {
        assets: [
            {
                id: IdAssetBundleBuildings.birdbath_2,
                offset: [3, -120],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-4, 87], [162, 3], [-6, -82], [-165, 6]],
            },
        ],
    }, birdbath3: {
        assets: [
            {
                id: IdAssetBundleBuildings.birdbath_3,
                offset: [0, -127],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 84], [163, 2], [0, -79], [-165, 2]],
            },
        ],
    }, butterflyFeeder1: {
        assets: [
            {
                id: IdAssetBundleBuildings.butterflyFeeder_1,
                offset: [-3, -51],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 79], [90, 30], [6, -46], [-90, 33]],
            },
        ],
    }, butterflyStatue1: {
        assets: [
            {
                id: IdAssetBundleBuildings.butterflyStatue_1,
                offset: [0, -52],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 78], [92, 26], [-19, -85], [-90, 28]],
            },
        ],
    }, camp1: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp_1,
                offset: [-55, -49],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[51, 55], [123, 16], [-43, -66], [-110, -22]],
            },
        ],
    }, camp11: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp1_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, camp21: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp2_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, camp31: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp3_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, camp41: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp4_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, camp51: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp5_1,
                offset: [1, -92],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-165, 6], [1, 91], [159, 9], [-1, -81]],
            },
        ],
    }, camp61: {
        assets: [
            {
                id: IdAssetBundleBuildings.camp6_1,
                offset: [0, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 88], [167, 9], [-1, -81], [-158, 5]],
            },
        ],
    }, candyChickenCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_1,
                offset: [0, -82],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_1_fence,
                offset: [0, -56],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [48, -25],
                radius: 84,
            },
            {
                type: 0,
                offset: [-55, -10],
                size: [5, -2],
            },
            {
                type: 1,
                offset: [-8, -7],
                radius: 77,
            },
        ],
    }, candyChickenCoop2: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_2,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_2_fence,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [36, -22],
                radius: 90,
            },
            {
                type: 0,
                offset: [-75, -1],
                size: [3, -2],
            },
            {
                type: 1,
                offset: [-58, 0],
                radius: 48,
            },
        ],
    }, candyChickenCoop3: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_3,
                offset: [-13, -93],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_3_fence,
                offset: [1, -54],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [44, -14],
                radius: 99,
            },
            {
                type: 0,
                offset: [-75, 5],
                size: [3, -2],
            },
            {
                type: 1,
                offset: [-34, 12],
                radius: 57,
            },
        ],
    }, candyChickenCoop4: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_4,
                offset: [-8, -90],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_4_fence,
                offset: [5, -55],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [44, -14],
                radius: 99,
            },
            {
                type: 0,
                offset: [-75, 5],
                size: [3, -2],
            },
            {
                type: 1,
                offset: [-34, 12],
                radius: 57,
            },
        ],
    }, candyChickenCoop5: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_5,
                offset: [-8, -103],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_5_fence,
                offset: [-8, -61],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [26, -14],
                radius: 103,
            },
            {
                type: 0,
                offset: [-82, 13],
                size: [3, -2],
            },
            {
                type: 1,
                offset: [-34, 12],
                radius: 66,
            },
        ],
    }, candyChickenCoop6: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_6,
                offset: [-8, -101],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_6_fence,
                offset: [3, -60],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [26, -14],
                radius: 103,
            },
            {
                type: 0,
                offset: [-82, 13],
                size: [3, -2],
            },
            {
                type: 1,
                offset: [-34, -7],
                radius: 78,
            },
        ],
    }, candyChickenCoop7: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_7,
                offset: [-5, -123],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_7_fence,
                offset: [0, -73],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [39, -14],
                radius: 109,
            },
            {
                type: 0,
                offset: [-82, 21],
                size: [3, -1],
            },
            {
                type: 1,
                offset: [-11, -23],
                radius: 107,
            },
        ],
    }, candyChickenCoop8: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyChickenCoop_8,
                offset: [-5, -123],
            },
            {
                id: IdAssetBundleBuildings.candyChickenCoop_8_fence,
                offset: [3, -71],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [39, -14],
                radius: 109,
            },
            {
                type: 0,
                offset: [-82, 21],
                size: [3, -1],
            },
            {
                type: 1,
                offset: [-11, -23],
                radius: 107,
            },
        ],
    }, candyCowBarn1: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_1,
                offset: [-75, -120],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_1_fence,
                offset: [-55, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 117], [220, 31], [32, -63], [-30, -132], [-103, -78], [-196, -14]],
            },
        ],
    }, candyCowBarn2: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_2,
                offset: [-81, -120],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_2_fence,
                offset: [-51, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 118], [225, 31], [64, -55], [62, -91], [-29, -123], [-194, -19]],
            },
        ],
    }, candyCowBarn3: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_3,
                offset: [-74, -115],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_3_fence,
                offset: [-52, -80],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[65, 116], [225, 35], [102, -33], [102, -67], [-19, -126], [-193, -19]],
            },
        ],
    }, candyCowBarn4: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_4,
                offset: [-71, -115],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_4_fence,
                offset: [-51, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[62, 118], [224, 33], [137, -15], [135, -53], [-19, -126], [-203, -16]],
            },
        ],
    }, candyCowBarn5: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_5,
                offset: [-68, -120],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_5_fence,
                offset: [-40, -86],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 123], [226, 40], [187, 10], [185, -32], [-16, -128], [-200, -12]],
            },
        ],
    }, candyCowBarn6: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_6,
                offset: [-69, -143],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_6_fence,
                offset: [-43, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [62, 135],
                    [228, 48],
                    [188, 17],
                    [128, -65],
                    [-52, -117],
                    [-99, -61],
                    [-202, -2],
                ],
            },
        ],
    }, candyCowBarn7: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyCowBarn_7,
                offset: [-79, -143],
            },
            {
                id: IdAssetBundleBuildings.candyCowBarn_7_fence,
                offset: [-51, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[74, 107], [184, 49], [195, -24], [-15, -147], [-155, -4]],
            },
        ],
    }, candyHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyHouse_1,
                offset: [0, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-149, 12], [3, 89], [147, 26], [66, -64], [-55, -105]],
            },
        ],
    }, candyHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyHouse_2,
                offset: [6, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-144, 5], [-12, 102], [147, 26], [100, -44], [-48, -114]],
            },
        ],
    }, candyHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyHouse_3,
                offset: [12, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-144, 5], [-12, 102], [147, 26], [100, -44], [-48, -114]],
            },
        ],
    }, candyHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyHouse_4,
                offset: [3, -141],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-144, 5], [-12, 102], [147, 26], [100, -44], [-48, -114]],
            },
        ],
    }, candyHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.candyHouse_5,
                offset: [3, -144],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-144, 5], [-12, 102], [147, 26], [100, -44], [-48, -114]],
            },
        ],
    }, cherryOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_1,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[34, 102], [214, 12], [-22, -105], [-198, -14]],
            },
        ],
    }, cherryOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_2,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[32, 104], [214, 13], [-24, -106], [-205, -13]],
            },
        ],
    }, cherryOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_3,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[33, 103], [214, 12], [-25, -108], [-204, -19]],
            },
        ],
    }, cherryOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_4,
                offset: [-46, -104],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 112], [213, 21], [128, -36], [12, -92], [-34, -102], [-215, -9]],
            },
        ],
    }, cherryOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_5,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, cherryOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_6,
                offset: [-47, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[29, 126], [214, 33], [108, -51], [14, -97], [-30, -88], [-212, 4]],
            },
        ],
    }, cherryOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_7,
                offset: [-40, -129],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [6, -13],
                radius: 127,
            },
        ],
    }, cherryOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.cherryOrchard_8,
                offset: [-40, -129],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [6, -13],
                radius: 127,
            },
        ],
    }, chickenBush1: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenBush_1,
                offset: [-2, -100],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, chickenCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.chickenCoop_1,
                offset: [0, -72],
            },
            {
                id: IdAssetBundleBuildingsInitial.chickenCoop_1_fence,
                offset: [0, -46],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, chickenCoop2: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_2,
                offset: [0, -72],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_2_fence,
                offset: [2, -46],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 83], [163, 0], [0, -87], [-160, 1]],
            },
        ],
    }, chickenCoop3: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_3,
                offset: [1, -78],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_3_fence,
                offset: [2, -45],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-1, 87], [159, 7], [1, -92], [-159, 8]],
            },
        ],
    }, chickenCoop4: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_4,
                offset: [1, -78],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_4_fence,
                offset: [2, -46],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-1, 85], [160, 3], [-1, -90], [-162, 6]],
            },
        ],
    }, chickenCoop5: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_5,
                offset: [1, -85],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_5_fence,
                offset: [3, -51],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-1, 95],
                    [165, 13],
                    [48, -48],
                    [28, -95],
                    [-28, -87],
                    [-50, -57],
                    [-161, 14],
                ],
            },
        ],
    }, chickenCoop6: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_6,
                offset: [1, -85],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_6_fence,
                offset: [2, -51],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-1, 99],
                    [166, 15],
                    [48, -47],
                    [47, -86],
                    [2, -102],
                    [-99, -50],
                    [-95, -36],
                    [-167, 14],
                ],
            },
        ],
    }, chickenCoop7: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_7,
                offset: [-12, -109],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_7_fence,
                offset: [-11, -61],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-1, 99], [134, 28], [-12, -114], [-86, -81], [-122, 24]],
            },
        ],
    }, chickenCoop8: {
        assets: [
            {
                id: IdAssetBundleBuildings.chickenCoop_8,
                offset: [-12, -109],
            },
            {
                id: IdAssetBundleBuildings.chickenCoop_8_fence,
                offset: [-11, -61],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-1, 99], [134, 28], [-12, -114], [-86, -81], [-122, 24]],
            },
        ],
    }, childOfTheWaves1: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_1,
                offset: [-6, -69],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, childOfTheWaves2: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_2,
                offset: [3, -76],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, childOfTheWaves3: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_3,
                offset: [0, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 86], [158, 8], [-3, -75], [-155, 7]],
            },
        ],
    }, childOfTheWaves4: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_4,
                offset: [-5, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 95], [161, 13], [4, -73], [-161, 13]],
            },
        ],
    }, childOfTheWaves5: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_5,
                offset: [-3, -98],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 99], [155, 22], [4, -65], [-148, 23]],
            },
        ],
    }, childOfTheWaves6: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_6,
                offset: [3, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 106], [151, 28], [-3, -62], [-154, 30]],
            },
        ],
    }, childOfTheWaves7: {
        assets: [
            {
                id: IdAssetBundleBuildings.childOfTheWaves_7,
                offset: [-1, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 110], [151, 35], [-2, -57], [-151, 35]],
            },
        ],
    }, christmasTree20191: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_1,
                offset: [-4, -124],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 33],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20192: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_2,
                offset: [-6, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 33],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20193: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_3,
                offset: [-6, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 33],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20194: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_4,
                offset: [-6, -132],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 50],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20195: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_5,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20196: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_6,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20197: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_7,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20198: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_8,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree20199: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_9,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, christmasTree201910: {
        assets: [
            {
                id: IdAssetBundleBuildings.christmasTree2019_10,
                offset: [-2, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 67],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, clothesline1: {
        assets: [
            {
                id: IdAssetBundleBuildings.clothesline_1,
                offset: [-41, -61],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[42, 81], [116, 37], [-57, -49], [-139, -10]],
            },
        ],
    }, composter1: {
        assets: [
            {
                id: IdAssetBundleBuildings.composter_1,
                offset: [-54, -46],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[53, 68], [140, 24], [56, -20], [14, -55], [-44, -70], [-130, -26]],
            },
        ],
    }, composter2: {
        assets: [
            {
                id: IdAssetBundleBuildings.composter_2,
                offset: [-51, -43],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[50, 65], [137, 20], [99, 1], [96, -32], [-47, -70], [-132, -24]],
            },
        ],
    }, composter3: {
        assets: [
            {
                id: IdAssetBundleBuildings.composter_3,
                offset: [-51, -49],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[51, 72], [134, 29], [99, 10], [96, -22], [-13, -78], [-126, -17]],
            },
        ],
    }, composter4: {
        assets: [
            {
                id: IdAssetBundleBuildings.composter_4,
                offset: [-52, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [51, 90],
                    [133, 43],
                    [100, 26],
                    [73, -11],
                    [97, -36],
                    [-27, -92],
                    [-29, -54],
                    [-124, -1],
                ],
            },
        ],
    }, composter5: {
        assets: [
            {
                id: IdAssetBundleBuildings.composter_5,
                offset: [-53, -67],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [10, -10],
                radius: 83,
            },
        ],
    }, cowBarn1: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_1,
                offset: [-58, -109],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_1_fence,
                offset: [-43, -80],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 117], [220, 31], [32, -63], [-30, -132], [-103, -78], [-196, -14]],
            },
        ],
    }, cowBarn2: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_2,
                offset: [-63, -103],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_2_fence,
                offset: [-41, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 118], [225, 31], [64, -55], [62, -91], [-29, -123], [-194, -19]],
            },
        ],
    }, cowBarn3: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_3,
                offset: [-65, -105],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_3_fence,
                offset: [-42, -76],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[65, 116], [225, 35], [102, -33], [102, -67], [-19, -126], [-193, -19]],
            },
        ],
    }, cowBarn4: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_4,
                offset: [-62, -104],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_4_fence,
                offset: [-39, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[62, 118], [224, 33], [137, -15], [135, -53], [-19, -126], [-203, -16]],
            },
        ],
    }, cowBarn5: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_5,
                offset: [-62, -108],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_5_fence,
                offset: [-88, -69],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 123], [226, 40], [187, 10], [185, -32], [-16, -128], [-200, -12]],
            },
        ],
    }, cowBarn6: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_6,
                offset: [-63, -118],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_6_fence,
                offset: [-86, -75],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [62, 135],
                    [228, 48],
                    [188, 17],
                    [128, -65],
                    [-52, -117],
                    [-99, -61],
                    [-202, -2],
                ],
            },
        ],
    }, cowBarn7: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowBarn_7,
                offset: [-76, -134],
            },
            {
                id: IdAssetBundleBuildings.cowBarn_7_fence,
                offset: [-99, -92],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[74, 107], [184, 49], [195, -24], [-15, -147], [-155, -4]],
            },
        ],
    }, cowCup1: {
        assets: [
            {
                id: IdAssetBundleBuildings.cowCup_1,
                offset: [-2, -79],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, cozyTeaGarden1: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_1,
                offset: [1, -100],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 99], [156, 21], [3, -77], [-159, 19]],
            },
        ],
    }, cozyTeaGarden2: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_2,
                offset: [1, -113],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 111], [155, 38], [-1, -65], [-155, 38]],
            },
        ],
    }, cozyTeaGarden3: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_3,
                offset: [-5, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 124], [163, 43], [5, -57], [-153, 45]],
            },
        ],
    }, cozyTeaGarden4: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_4,
                offset: [-5, -125],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 127], [168, 46], [3, -54], [-154, 47]],
            },
        ],
    }, cozyTeaGarden5: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_5,
                offset: [-2, -125],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 126], [155, 50], [1, -65], [-152, 51]],
            },
        ],
    }, cozyTeaGarden6: {
        assets: [
            {
                id: IdAssetBundleBuildings.cozyTeaGarden_6,
                offset: [4, -130],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 133], [158, 53], [-3, -57], [-156, 55]],
            },
        ],
    }, crater1: {
        assets: [
            {
                id: IdAssetBundleBuildings.crater_1,
                offset: [-5, -30],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 44], [76, 1], [5, -37], [-39, -48], [-78, -1]],
            },
        ],
    }, cropCircles1: {
        assets: [
            {
                id: IdAssetBundleBuildings.cropCircles_1,
                offset: [-41, -37],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[33, 32], [92, 3], [-36, -65], [-92, -33]],
            },
        ],
    }, deadTree1: {
        assets: [
            {
                id: IdAssetBundleBuildings.deadTree_1,
                offset: [-12, -140],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[13, 140], [157, 67], [-2, -16], [-137, 53]],
            },
        ],
    }, dragonDance11: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance1_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, dragonDance21: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance2_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, dragonDance31: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance3_1,
                offset: [3, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 89], [160, 4], [-1, -81], [-160, 8]],
            },
        ],
    }, dragonDance41: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance4_1,
                offset: [-3, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 90], [167, 8], [-1, -81], [-159, 8]],
            },
        ],
    }, dragonDance51: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance5_1,
                offset: [1, -88],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 88], [161, 7], [-1, -81], [-162, 6]],
            },
        ],
    }, dragonDance61: {
        assets: [
            {
                id: IdAssetBundleBuildings.dragonDance6_1,
                offset: [-5, -92],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 89], [164, 8], [6, -78], [-161, 10]],
            },
        ],
    }, duckCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_1,
                offset: [-58, -94],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_1_fence,
                offset: [-46, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-21, -103], [68, -110], [180, 0], [50, 77], [-154, -31]],
            },
        ],
    }, duckCoop2: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_2,
                offset: [-65, -89],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_2_fence,
                offset: [-50, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[44, 78], [177, 3], [62, -108], [-15, -105], [-157, -27]],
            },
        ],
    }, duckCoop3: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_3,
                offset: [-58, -97],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_3_fence,
                offset: [-46, -71],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[34, 81], [177, 6], [71, -116], [-15, -103], [-153, -18]],
            },
        ],
    }, duckCoop4: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_4,
                offset: [-62, -101],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_4_fence,
                offset: [-52, -69],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-157, -22], [39, 86], [179, 13], [52, -121], [-53, -90]],
            },
        ],
    }, duckCoop5: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_5,
                offset: [-59, -106],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_5_fence,
                offset: [-46, -69],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[37, 95], [182, 20], [60, -124], [-88, -92], [-161, -17]],
            },
        ],
    }, duckCoop6: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_6,
                offset: [-60, -106],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_6_fence,
                offset: [-47, -70],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 93], [180, 20], [58, -128], [-61, -103], [-111, -76], [-158, -10]],
            },
        ],
    }, duckCoop7: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_7,
                offset: [-60, -119],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_7_fence,
                offset: [-47, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 93], [180, 20], [58, -128], [-61, -103], [-111, -76], [-158, -10]],
            },
        ],
    }, duckCoop8: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckCoop_8,
                offset: [-60, -119],
            },
            {
                id: IdAssetBundleBuildings.duckCoop_8_fence,
                offset: [-47, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 93], [180, 20], [58, -128], [-61, -103], [-111, -76], [-158, -10]],
            },
        ],
    }, duckPond1: {
        assets: [
            {
                id: IdAssetBundleBuildings.duckPond_1,
                offset: [-4, -26],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[12, 52], [78, 8], [-30, -50], [-75, 1]],
            },
        ],
    }, easterBunnyInc1: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnyInc_1,
                offset: [-50, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[45, 139], [264, 15], [157, -121], [-88, -214], [-241, -29], [-182, 11]],
            },
        ],
    }, easterBunnysHome1: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_1,
                offset: [7, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 86], [138, -2], [-5, -81], [-91, -62], [-165, 4]],
            },
        ],
    }, easterBunnysHome2: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_2,
                offset: [7, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 86], [138, -2], [-5, -81], [-91, -62], [-165, 4]],
            },
        ],
    }, easterBunnysHome3: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_3,
                offset: [7, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-7, 83], [138, -2], [-5, -81], [-100, -67], [-165, 4]],
            },
        ],
    }, easterBunnysHome4: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_4,
                offset: [7, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 86], [138, -2], [-5, -81], [-109, -53], [-165, 4]],
            },
        ],
    }, easterBunnysHome5: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_5,
                offset: [5, -109],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-10, 100], [145, 19], [12, -107], [-111, -40], [-146, 23]],
            },
        ],
    }, easterBunnysHome6: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_6,
                offset: [10, -107],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-8, 104], [148, 26], [14, -114], [-91, -62], [-166, 23]],
            },
        ],
    }, easterBunnysHome7: {
        assets: [
            {
                id: IdAssetBundleBuildings.easterBunnysHome_7,
                offset: [4, -106],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-9, 103], [157, 24], [11, -113], [-91, -62], [-164, 23]],
            },
        ],
    }, elvesTable1: {
        assets: [
            {
                id: IdAssetBundleBuildings.elvesTable_1,
                offset: [4, -26],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 51], [77, 10], [13, -56], [-79, 3]],
            },
        ],
    }, enchantedTree1: {
        assets: [
            {
                id: IdAssetBundleBuildings.enchantedTree_1,
                offset: [1, -114],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 113], [142, 41], [6, -47], [-137, 42]],
            },
        ],
    }, extravagantElderBush1: {
        assets: [
            {
                id: IdAssetBundleBuildings.extravagantElderBush_1,
                offset: [-3, -190],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 188], [164, 101], [98, -158], [-53, -198], [-113, -155], [-154, 106]],
            },
        ],
    }, fairytaleTower11: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower1_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fairytaleTower21: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower2_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fairytaleTower31: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower3_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fairytaleTower41: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower4_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fairytaleTower51: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower5_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fairytaleTower61: {
        assets: [
            {
                id: IdAssetBundleBuildings.fairytaleTower6_1,
                offset: [0, -131],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 17],
                radius: 133,
            },
        ],
    }, fancyHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fancyHouse_1,
                offset: [-5, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-149, 12],
                    [3, 89],
                    [155, 12],
                    [70, -32],
                    [66, -64],
                    [-32, -106],
                    [-85, -34],
                ],
            },
        ],
    }, fancyHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fancyHouse_2,
                offset: [0, -94],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-2, 110],
                    [171, 20],
                    [95, -19],
                    [95, -53],
                    [-37, -106],
                    [-85, -31],
                    [-165, 20],
                ],
            },
        ],
    }, fancyHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fancyHouse_3,
                offset: [-4, -119],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 119], [151, 40], [1, -81], [-147, 44]],
            },
        ],
    }, fancyHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fancyHouse_4,
                offset: [-11, -124],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[11, 122], [165, 44], [65, -29], [3, -124], [-55, -37], [-144, 42]],
            },
        ],
    }, fancyHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fancyHouse_5,
                offset: [-11, -124],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 0],
                radius: 123,
            },
        ],
    }, farmHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.farmHouse_1,
                offset: [-4, -173],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [6, 169],
                    [247, 52],
                    [65, -56],
                    [20, -194],
                    [-109, -111],
                    [-121, -26],
                    [-240, 49],
                ],
            },
        ],
    }, farmHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.farmHouse_2,
                offset: [-6, -171],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [5, 169],
                    [269, 40],
                    [67, -60],
                    [13, -197],
                    [-180, -65],
                    [-183, 5],
                    [-247, 43],
                ],
            },
        ],
    }, farmHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.farmHouse_3,
                offset: [-2, -172],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [2, 171],
                    [267, 40],
                    [114, -38],
                    [-2, -184],
                    [-171, -88],
                    [-194, 7],
                    [-257, 41],
                ],
            },
        ],
    }, farmHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.farmHouse_4,
                offset: [-1, -199],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [0, 197],
                    [264, 66],
                    [122, -5],
                    [34, -82],
                    [-6, -215],
                    [-125, -145],
                    [-196, 30],
                    [-262, 67],
                ],
            },
        ],
    }, farmHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.farmHouse_5,
                offset: [-9, -209],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [10, 206],
                    [270, 76],
                    [201, 40],
                    [78, -86],
                    [28, -232],
                    [-161, -110],
                    [-175, 34],
                    [-254, 78],
                ],
            },
        ],
    }, farmHouse6: {
        assets: [
            {
                id: IdAssetBundleBuildings.farmHouse_6,
                offset: [-7, -207],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [6, 206],
                    [272, 75],
                    [206, 42],
                    [197, -19],
                    [139, -53],
                    [66, -169],
                    [33, -231],
                    [-150, -128],
                    [-191, 39],
                    [-260, 74],
                ],
            },
        ],
    }, fertileAcre1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_1,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-194, -28], [59, 96], [217, 13], [-31, -108]],
            },
        ],
    }, fertileAcre2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_2,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[44, 90], [204, 9], [-23, -107], [-185, -26]],
            },
        ],
    }, fertileAcre3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_3,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[53, 102], [221, 13], [-33, -117], [-200, -29]],
            },
        ],
    }, fertileAcre4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_4,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, fertileAcre5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_5,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[56, 96], [220, 14], [-33, -113], [-206, -27]],
            },
        ],
    }, fertileAcre6: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_6,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, fertileAcre7: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_7,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, fertileAcre8: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAcre_8,
                offset: [-59, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 100], [219, 14], [-33, -112], [-203, -25]],
            },
        ],
    }, fertileAlmondOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_1,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAlmondOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_2,
                offset: [-49, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, fertileAlmondOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_3,
                offset: [-50, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 113], [217, 24], [121, -39], [4, -101], [-30, -98], [-206, -11]],
            },
        ],
    }, fertileAlmondOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_4,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertileAlmondOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_5,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertileAlmondOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_6,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertileAlmondOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_7,
                offset: [-44, -125],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, -10],
                radius: 118,
            },
        ],
    }, fertileAlmondOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAlmondOrchard_8,
                offset: [-43, -126],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [3, -9],
                radius: 118,
            },
        ],
    }, fertileAppleOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_1,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAppleOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_2,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAppleOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_3,
                offset: [-50, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAppleOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_4,
                offset: [-50, -107],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAppleOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_5,
                offset: [-50, -103],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, fertileAppleOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_6,
                offset: [-49, -120],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-223, -3],
                    [37, 126],
                    [215, 36],
                    [142, -11],
                    [137, -47],
                    [-5, -110],
                    [-38, -90],
                ],
            },
        ],
    }, fertileAppleOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_7,
                offset: [-42, -140],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [5, -11],
                radius: 127,
            },
        ],
    }, fertileAppleOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileAppleOrchard_8,
                offset: [-42, -141],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [4, -15],
                radius: 127,
            },
        ],
    }, fertileCherryOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_1,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[34, 102], [214, 12], [-22, -105], [-198, -14]],
            },
        ],
    }, fertileCherryOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_2,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[32, 104], [214, 13], [-24, -106], [-205, -13]],
            },
        ],
    }, fertileCherryOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_3,
                offset: [-47, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[33, 103], [214, 12], [-25, -108], [-204, -19]],
            },
        ],
    }, fertileCherryOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_4,
                offset: [-46, -104],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 112], [213, 21], [128, -36], [12, -92], [-34, -102], [-215, -9]],
            },
        ],
    }, fertileCherryOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_5,
                offset: [-46, -111],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertileCherryOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_6,
                offset: [-47, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[29, 126], [214, 33], [108, -51], [14, -97], [-30, -88], [-212, 4]],
            },
        ],
    }, fertileCherryOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_7,
                offset: [-40, -129],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [6, -13],
                radius: 127,
            },
        ],
    }, fertileCherryOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertileCherryOrchard_8,
                offset: [-40, -129],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [6, -13],
                radius: 127,
            },
        ],
    }, fertilePeachOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_1,
                offset: [-56, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, fertilePeachOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_2,
                offset: [-56, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, fertilePeachOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_3,
                offset: [-54, -99],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertilePeachOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_4,
                offset: [-54, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertilePeachOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_5,
                offset: [-55, -113],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertilePeachOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_6,
                offset: [-59, -125],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, fertilePeachOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_7,
                offset: [-45, -143],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [9, -13],
                radius: 134,
            },
        ],
    }, fertilePeachOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.fertilePeachOrchard_8,
                offset: [-46, -145],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [9, -13],
                radius: 134,
            },
        ],
    }, flowerbed1: {
        assets: [
            {
                id: IdAssetBundleBuildings.flowerbed_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 62], [89, 19], [-7, -42], [-82, 18]],
            },
        ],
    }, foodTruck1: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_1,
                offset: [-1, -68],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 70], [164, -14], [3, -94], [-163, -14]],
            },
        ],
    }, foodTruck2: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_2,
                offset: [5, -71],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 62], [151, -13], [-13, -100], [-151, -16]],
            },
        ],
    }, foodTruck3: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_3,
                offset: [7, -82],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-10, 91], [160, -1], [-29, -108], [-154, 1]],
            },
        ],
    }, foodTruck4: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_4,
                offset: [0, -97],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-11, 108], [151, 15], [8, -124], [-160, 11]],
            },
        ],
    }, foodTruck5: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_5,
                offset: [-3, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[10, 107], [157, 24], [96, -71], [-2, -125], [-157, 16]],
            },
        ],
    }, foodTruck6: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_6,
                offset: [-2, -102],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 109], [161, 25], [-9, -129], [-141, 16]],
            },
        ],
    }, foodTruck7: {
        assets: [
            {
                id: IdAssetBundleBuildings.foodTruck_7,
                offset: [-2, -109],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 117], [157, 25], [0, -126], [-147, -82], [-150, 24]],
            },
        ],
    }, footballoons1: {
        assets: [
            {
                id: IdAssetBundleBuildings.footballoons_1,
                offset: [-7, -53],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 84], [73, 46], [58, -68], [-13, -90], [-76, 37]],
            },
        ],
    }, freeRangeAlmondOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeAlmondOrchard_1,
                offset: [-56, -131],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-27, -77], [207, 42], [47, 126], [-192, 6]],
            },
        ],
    }, freeRangeAppleOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeAppleOrchard_1,
                offset: [-56, -131],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-27, -77], [207, 42], [47, 126], [-192, 6]],
            },
        ],
    }, freeRangeCherryOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeCherryOrchard_1,
                offset: [-56, -131],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-27, -77], [207, 42], [47, 126], [-192, 6]],
            },
        ],
    }, freeRangeChickenCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeChickenCoop_1,
                offset: [-8, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 97], [178, 5], [22, -95], [-170, 2]],
            },
        ],
    }, freeRangeCowBarn1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeCowBarn_1,
                offset: [-62, -118],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [58, 98],
                    [198, 25],
                    [88, -49],
                    [85, -85],
                    [13, -121],
                    [-40, -92],
                    [-179, -19],
                ],
            },
        ],
    }, freeRangeDuckCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeDuckCoop_1,
                offset: [-65, -94],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [58, 98],
                    [198, 25],
                    [88, -49],
                    [85, -85],
                    [13, -121],
                    [-40, -92],
                    [-179, -19],
                ],
            },
        ],
    }, freeRangeGoatStable1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangeGoatStable_1,
                offset: [-8, -70],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 116], [155, 42], [9, -63], [-151, 38]],
            },
        ],
    }, freeRangePigPen1: {
        assets: [
            {
                id: IdAssetBundleBuildings.freeRangePigPen_1,
                offset: [-68, -97],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [58, 98],
                    [198, 25],
                    [88, -49],
                    [85, -85],
                    [13, -121],
                    [-40, -92],
                    [-179, -19],
                ],
            },
        ],
    }, frogPrinceWell1: {
        assets: [
            {
                id: IdAssetBundleBuildings.frogPrinceWell_1,
                offset: [0, -23],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 43], [78, 1], [2, -48], [-76, -5]],
            },
        ],
    }, galacticGarden1: {
        assets: [
            {
                id: IdAssetBundleBuildings.galacticGarden_1,
                offset: [-14, -104],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[27, 97], [142, 41], [-14, -46], [-129, 16]],
            },
        ],
    }, gingerBreadHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gingerBreadHouse_1,
                offset: [2, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, gnomeBath1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeBath_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 69], [89, 19], [-29, -71], [-77, 22]],
            },
        ],
    }, gnomeDate1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeDate_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 74], [78, 32], [-14, -82], [-79, 28]],
            },
        ],
    }, gnomeFishing1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeFishing_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 62], [69, 24], [34, -66], [-29, -51], [-78, 18]],
            },
        ],
    }, gnomeFlowers1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeFlowers_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 74], [74, 35], [31, -76], [-13, -79], [-76, 28]],
            },
        ],
    }, gnomeHome1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHome_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 74], [77, 29], [-13, -77], [-77, 25]],
            },
        ],
    }, gnomeHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHouse_1,
                offset: [-8, -81],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[9, 71], [151, -5], [7, -82], [-140, -6]],
            },
        ],
    }, gnomeHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHouse_2,
                offset: [-7, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[9, 95], [144, 27], [3, -58], [-137, 23]],
            },
        ],
    }, gnomeHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHouse_3,
                offset: [-6, -105],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 104], [126, 45], [2, -72], [-118, 42]],
            },
        ],
    }, gnomeHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHouse_4,
                offset: [0, -115],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 114], [120, 55], [-4, -63], [-116, 56]],
            },
        ],
    }, gnomeHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomeHouse_5,
                offset: [0, -115],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 2],
                radius: 124,
            },
        ],
    }, gnomePinwheels1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gnomePinwheels_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 80], [73, 39], [-11, -85], [-75, 33]],
            },
        ],
    }, goatStable1: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_1,
                offset: [-3, -99],
            },
            {
                id: IdAssetBundleBuildings.goatStable_1_fence,
                offset: [-3, -46],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, -99], [162, 18], [3, 98], [-156, 17]],
            },
        ],
    }, goatStable2: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_2,
                offset: [-2, -97],
            },
            {
                id: IdAssetBundleBuildings.goatStable_2_fence,
                offset: [-3, -45],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 96], [163, 15], [5, -106], [-152, 13]],
            },
        ],
    }, goatStable3: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_3,
                offset: [-3, -96],
            },
            {
                id: IdAssetBundleBuildings.goatStable_3_fence,
                offset: [-4, -49],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 93], [161, 11], [4, -98], [-160, 10]],
            },
        ],
    }, goatStable4: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_4,
                offset: [-2, -102],
            },
            {
                id: IdAssetBundleBuildings.goatStable_4_fence,
                offset: [-4, -49],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 98], [162, 18], [3, -98], [-155, 19]],
            },
        ],
    }, goatStable5: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_5,
                offset: [-3, -120],
            },
            {
                id: IdAssetBundleBuildings.goatStable_5_fence,
                offset: [-4, -49],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 115], [158, 39], [-6, -128], [-102, -76], [-153, 37]],
            },
        ],
    }, goatStable6: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_6,
                offset: [-3, -122],
            },
            {
                id: IdAssetBundleBuildings.goatStable_6_fence,
                offset: [-4, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 119], [159, 40], [-7, -128], [-101, -78], [-163, 37]],
            },
        ],
    }, goatStable7: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_7,
                offset: [-3, -128],
            },
            {
                id: IdAssetBundleBuildings.goatStable_7_fence,
                offset: [-4, -54],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 124], [155, 45], [-7, -129], [-100, -75], [-150, 48]],
            },
        ],
    }, goatStable8: {
        assets: [
            {
                id: IdAssetBundleBuildings.goatStable_8,
                offset: [3, -128],
            },
            {
                id: IdAssetBundleBuildings.goatStable_8_fence,
                offset: [1, -54],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 124], [155, 45], [-7, -129], [-100, -75], [-150, 48]],
            },
        ],
    }, goldenSoccerBall1: {
        assets: [
            {
                id: IdAssetBundleBuildings.goldenSoccerBall_1,
                offset: [-6, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 106], [157, 32], [6, -59], [-143, 32]],
            },
        ],
    }, gumballMachine1: {
        assets: [
            {
                id: IdAssetBundleBuildings.gumballMachine_1,
                offset: [-2, -41],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 70], [91, 24], [0, -69], [-88, 24]],
            },
        ],
    }, hauntedCastle1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedCastle_1,
                offset: [-3, -168],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 33],
                radius: 133,
            },
        ],
    }, hauntedHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_1,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 32],
                radius: 133,
            },
        ],
    }, hauntedHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_2,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 25],
                radius: 136,
            },
        ],
    }, hauntedHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_3,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, hauntedHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_4,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, hauntedHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_5,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, hauntedHouse6: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_6,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, hauntedHouse7: {
        assets: [
            {
                id: IdAssetBundleBuildings.hauntedHouse_7,
                offset: [-1, -159],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, hawaiianBeach1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hawaiianBeach_1,
                offset: [-3, -100],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 95], [155, 22], [7, -54], [-138, 21]],
            },
        ],
    }, hawaiianFountain1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hawaiianFountain_1,
                offset: [-46, -52],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[39, 56], [112, 18], [-32, -54], [-98, -13]],
            },
        ],
    }, hayBale1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hayBale_1,
                offset: [6, -21],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 45], [83, 3], [-11, -49], [-91, 1]],
            },
        ],
    }, heartTrees1: {
        assets: [
            {
                id: IdAssetBundleBuildings.heartTrees_1,
                offset: [-7, -90],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 84], [73, 46], [58, -68], [-13, -90], [-76, 37]],
            },
        ],
    }, hotSprings1: {
        assets: [
            {
                id: IdAssetBundleBuildings.hotSprings_1,
                offset: [-2, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [176, -1], [2, -88], [-163, -3]],
            },
        ],
    }, hotSprings2: {
        assets: [
            {
                id: IdAssetBundleBuildings.hotSprings_2,
                offset: [1, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-140, 26], [-1, 104], [145, 27], [0, -54]],
            },
        ],
    }, hotSprings3: {
        assets: [
            {
                id: IdAssetBundleBuildings.hotSprings_3,
                offset: [1, -96],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 108], [156, 31], [-3, -55], [-147, 26]],
            },
        ],
    }, jackOLantern1: {
        assets: [
            {
                id: IdAssetBundleBuildings.jackOLantern_1,
                offset: [-46, -76],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[30, 71], [97, 31], [-22, -28], [-81, 11]],
            },
        ],
    }, koiPond1: {
        assets: [
            {
                id: IdAssetBundleBuildings.koiPond_1,
                offset: [-47, -53],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[34, 55], [110, 19], [-34, -52], [-99, -17]],
            },
        ],
    }, lavaSpring1: {
        assets: [
            {
                id: IdAssetBundleBuildings.lavaSpring_1,
                offset: [-2, -28],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 48], [82, 2], [-11, -51], [-83, 5]],
            },
        ],
    }, logBridge1: {
        assets: [
            {
                id: IdAssetBundleBuildings.logBridge_1,
                offset: [-1, -24],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 50], [91, 2], [-16, -55], [-92, 3]],
            },
        ],
    }, magicalWinterTree1: {
        assets: [
            {
                id: IdAssetBundleBuildings.magicalWinterTree_1,
                offset: [-3, -168],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 33],
                radius: 133,
            },
        ],
    }, manufactory1: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_1,
                offset: [0, -101],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 103], [158, 14], [46, -107], [-164, 18]],
            },
        ],
    }, manufactory2: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_2,
                offset: [-10, -100],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 99], [161, 18], [72, -107], [12, -112], [-110, -47], [-145, 36]],
            },
        ],
    }, manufactory3: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_3,
                offset: [-14, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[14, 113], [179, 24], [87, -90], [9, -110], [-115, -42], [-141, 27]],
            },
        ],
    }, manufactory4: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_4,
                offset: [-14, -118],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[13, 123], [176, 33], [57, -122], [-119, -42], [-143, 32]],
            },
        ],
    }, manufactory5: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_5,
                offset: [2, -126],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [1, 124],
                    [142, 38],
                    [135, -55],
                    [71, -128],
                    [14, -129],
                    [-122, -48],
                    [-156, 39],
                ],
            },
        ],
    }, manufactory6: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_6,
                offset: [-7, -124],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 135], [170, 42], [72, -115], [35, -131], [-138, -32], [-157, 57]],
            },
        ],
    }, manufactory7: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_7,
                offset: [-8, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[10, 143], [166, 50], [100, -120], [64, -143], [-146, -27], [-157, 57]],
            },
        ],
    }, manufactory8: {
        assets: [
            {
                id: IdAssetBundleBuildings.manufactory_8,
                offset: [-14, -136],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[10, 143], [183, 51], [104, -120], [65, -143], [-143, -25], [-157, 57]],
            },
        ],
    }, meadow1: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_1,
                offset: [-54, -98],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow2: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_2,
                offset: [-55, -103],
            },
            {
                id: IdAssetBundleBuildings.meadow_2_fence,
                offset: [-42, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow3: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_3,
                offset: [-55, -103],
            },
            {
                id: IdAssetBundleBuildings.meadow_3_fence,
                offset: [-42, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow4: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_4,
                offset: [-55, -103],
            },
            {
                id: IdAssetBundleBuildings.meadow_4_fence,
                offset: [-46, -71],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow5: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_5,
                offset: [-56, -103],
            },
            {
                id: IdAssetBundleBuildings.meadow_5_fence,
                offset: [-44, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow6: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_6,
                offset: [-55, -103],
            },
            {
                id: IdAssetBundleBuildings.meadow_6_fence,
                offset: [-39, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, meadow7: {
        assets: [
            {
                id: IdAssetBundleBuildings.meadow_7,
                offset: [-54, -110],
            },
            {
                id: IdAssetBundleBuildings.meadow_7_fence,
                offset: [-43, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[57, 100], [227, 13], [-36, -116], [-205, -29]],
            },
        ],
    }, mysticStoneDragon1: {
        assets: [
            {
                id: IdAssetBundleBuildings.mysticStoneDragon_1,
                offset: [2, -75],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 69], [137, 2], [-6, -76], [-147, -11]],
            },
        ],
    }, nordlandDuckCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_1,
                offset: [-58, -111],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_1_fence,
                offset: [-57, -80],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-106, -136], [-45, -146], [236, 17], [64, 109], [-207, -22]],
            },
        ],
    }, nordlandDuckCoop2: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_2,
                offset: [-58, -121],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_3_fence,
                offset: [-59, -86],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-106, -136], [-45, -146], [236, 17], [64, 109], [-207, -22]],
            },
        ],
    }, nordlandDuckCoop3: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_3,
                offset: [-60, -122],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_3_fence,
                offset: [-59, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-45, -146], [236, 17], [64, 109], [-217, -20]],
            },
        ],
    }, nordlandDuckCoop4: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_4,
                offset: [-60, -121],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_4_fence,
                offset: [-59, -90],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-45, -146], [236, 17], [64, 109], [-207, -22]],
            },
        ],
    }, nordlandDuckCoop5: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_5,
                offset: [-56, -132],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_5_fence,
                offset: [-56, -83],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-78, -162], [219, 45], [57, 134], [-212, -1]],
            },
        ],
    }, nordlandDuckCoop6: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_6,
                offset: [-58, -141],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_6_fence,
                offset: [-57, -81],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-159, -118], [-79, -153], [66, -131], [229, 54], [60, 138], [-214, 6]],
            },
        ],
    }, nordlandDuckCoop7: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_7,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_7_fence,
                offset: [-59, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-172, -106], [-68, -159], [67, -126], [222, 47], [60, 130], [-218, 3]],
            },
        ],
    }, nordlandDuckCoop8: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_8,
                offset: [-60, -139],
            },
            {
                id: IdAssetBundleBuildings.nordlandDuckCoop_8_fence,
                offset: [-59, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-172, -106], [-68, -159], [67, -126], [222, 47], [60, 130], [-218, 3]],
            },
        ],
    }, nordlandGoatStable1: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_1,
                offset: [-3, -116],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_1_fence,
                offset: [-3, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-101, -95], [-3, -137], [169, 37], [4, 116], [-164, 34]],
            },
        ],
    }, nordlandGoatStable2: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_2,
                offset: [-1, -120],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_2_fence,
                offset: [-1, -52],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-105, -88], [-3, -137], [169, 37], [4, 116], [-164, 34]],
            },
        ],
    }, nordlandGoatStable3: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_3,
                offset: [-1, -137],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_3_fence,
                offset: [-1, -45],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-134, -74], [-24, -148], [169, 55], [4, 138], [-170, 57]],
            },
        ],
    }, nordlandGoatStable4: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_4,
                offset: [-4, -139],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_4_fence,
                offset: [-4, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-134, -74], [-24, -148], [169, 55], [4, 138], [-170, 57]],
            },
        ],
    }, nordlandGoatStable5: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_5,
                offset: [-13, -147],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_5_fence,
                offset: [-1, -47],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-127, -92], [-17, -158], [178, 61], [16, 146], [-161, 57]],
            },
        ],
    }, nordlandGoatStable6: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_6,
                offset: [-1, -149],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_6_fence,
                offset: [-1, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-138, -88], [-18, -158], [174, 64], [6, 150], [-169, 68]],
            },
        ],
    }, nordlandGoatStable7: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_7,
                offset: [3, -147],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_7_fence,
                offset: [3, -47],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-135, -95], [-18, -158], [174, 64], [6, 150], [-169, 68]],
            },
        ],
    }, nordlandGoatStable8: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_8,
                offset: [3, -147],
            },
            {
                id: IdAssetBundleBuildings.nordlandGoatStable_8_fence,
                offset: [3, -47],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-135, -95], [-18, -158], [174, 64], [6, 150], [-169, 68]],
            },
        ],
    }, nordlandHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandHouse_1,
                offset: [-3, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-139, 25], [3, 89], [134, 33], [90, -57], [-32, -107]],
            },
        ],
    }, nordlandHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandHouse_2,
                offset: [-3, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-139, 25], [3, 89], [134, 33], [90, -57], [-32, -107]],
            },
        ],
    }, nordlandHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandHouse_3,
                offset: [-3, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-139, 25], [3, 89], [134, 33], [90, -57], [-32, -107]],
            },
        ],
    }, nordlandHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandHouse_4,
                offset: [1, -139],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-141, 9], [0, 119], [138, 60], [-15, -143]],
            },
        ],
    }, nordlandHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.nordlandHouse_5,
                offset: [1, -139],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [-5, 10],
                radius: 136,
            },
        ],
    }, oasisPool1: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_1,
                offset: [0, -72],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, oasisPool2: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_2,
                offset: [0, -72],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 83], [174, -4], [0, -91], [-167, -5]],
            },
        ],
    }, oasisPool3: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_3,
                offset: [-2, -81],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[4, 83], [170, -3], [2, -84], [-159, -2]],
            },
        ],
    }, oasisPool4: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_4,
                offset: [-2, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 83], [172, 3], [2, -83], [-163, 5]],
            },
        ],
    }, oasisPool5: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_5,
                offset: [-4, -89],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 95], [174, 11], [5, -78], [-167, 11]],
            },
        ],
    }, oasisPool6: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_6,
                offset: [-2, -93],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 94], [174, 14], [3, -71], [-160, 13]],
            },
        ],
    }, oasisPool7: {
        assets: [
            {
                id: IdAssetBundleBuildings.oasisPool_7,
                offset: [2, -118],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 119], [163, 36], [10, -69], [-165, 37]],
            },
        ],
    }, ornamentalTree1: {
        assets: [
            {
                id: IdAssetBundleBuildings.ornamentalTree_1,
                offset: [-1, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [3, 91],
                    [84, 53],
                    [20, 23],
                    [79, -32],
                    [57, -71],
                    [-16, -91],
                    [-87, -12],
                    [-26, 26],
                    [-82, 53],
                ],
            },
        ],
    }, pavilion1: {
        assets: [
            {
                id: IdAssetBundleBuildings.pavilion_1,
                offset: [2, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-1, 75],
                    [74, 32],
                    [66, -56],
                    [19, -84],
                    [-26, -58],
                    [-25, -2],
                    [-72, 40],
                ],
            },
        ],
    }, peachOrchard1: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_1,
                offset: [-55, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-24, -107], [215, 14], [42, 100], [-200, -19]],
            },
        ],
    }, peachOrchard2: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_2,
                offset: [-56, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[36, 108], [216, 18], [176, -11], [5, -98], [-37, -108], [-210, -16]],
            },
        ],
    }, peachOrchard3: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_3,
                offset: [-54, -99],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, peachOrchard4: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_4,
                offset: [-54, -110],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, peachOrchard5: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_5,
                offset: [-55, -113],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, peachOrchard6: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_6,
                offset: [-59, -125],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[31, 118], [211, 27], [114, -40], [8, -99], [-26, -92], [-205, 0]],
            },
        ],
    }, peachOrchard7: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_7,
                offset: [-45, -143],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [9, -13],
                radius: 134,
            },
        ],
    }, peachOrchard8: {
        assets: [
            {
                id: IdAssetBundleBuildings.peachOrchard_8,
                offset: [-46, -145],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [9, -13],
                radius: 134,
            },
        ],
    }, picnicTable1: {
        assets: [
            {
                id: IdAssetBundleBuildings.picnicTable_1,
                offset: [2, -88],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 99], [169, 12], [-3, -81], [-172, 12]],
            },
        ],
    }, pigPen1: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_1,
                offset: [-62, -124],
            },
            {
                id: IdAssetBundleBuildings.pigPen_1_fence,
                offset: [-37, -68],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [60, 135],
                    [227, 41],
                    [82, -32],
                    [76, -84],
                    [-16, -144],
                    [-118, -40],
                    [-192, 8],
                ],
            },
        ],
    }, pigPen2: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_2,
                offset: [-62, -124],
            },
            {
                id: IdAssetBundleBuildings.pigPen_2_fence,
                offset: [-38, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [58, 145],
                    [231, 54],
                    [147, 9],
                    [138, -64],
                    [-11, -140],
                    [-117, -35],
                    [-197, 9],
                ],
            },
        ],
    }, pigPen3: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_3,
                offset: [-63, -126],
            },
            {
                id: IdAssetBundleBuildings.pigPen_3_fence,
                offset: [-67, -68],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [61, 138],
                    [226, 45],
                    [188, 23],
                    [181, -37],
                    [-11, -135],
                    [-109, -40],
                    [-193, 10],
                ],
            },
        ],
    }, pigPen4: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_4,
                offset: [-62, -133],
            },
            {
                id: IdAssetBundleBuildings.pigPen_4_fence,
                offset: [-67, -69],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [63, 148],
                    [230, 53],
                    [189, 35],
                    [183, -33],
                    [-12, -131],
                    [-113, -31],
                    [-196, 18],
                ],
            },
        ],
    }, pigPen5: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_5,
                offset: [-60, -161],
            },
            {
                id: IdAssetBundleBuildings.pigPen_5_fence,
                offset: [-65, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [61, 174],
                    [227, 81],
                    [189, 63],
                    [181, 0],
                    [-8, -108],
                    [-116, -3],
                    [-193, 47],
                ],
            },
        ],
    }, pigPen6: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_6,
                offset: [-62, -156],
            },
            {
                id: IdAssetBundleBuildings.pigPen_6_fence,
                offset: [-68, -68],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [61, 169],
                    [227, 75],
                    [185, 54],
                    [141, -65],
                    [-21, -113],
                    [-46, -69],
                    [-140, 6],
                    [-201, 43],
                ],
            },
        ],
    }, pigPen7: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_7,
                offset: [-66, -172],
            },
            {
                id: IdAssetBundleBuildings.pigPen_7_fence,
                offset: [-72, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 169], [227, 75], [185, 54], [55, -148], [-201, 43]],
            },
        ],
    }, pigPen8: {
        assets: [
            {
                id: IdAssetBundleBuildings.pigPen_8,
                offset: [-66, -172],
            },
            {
                id: IdAssetBundleBuildings.pigPen_8_fence,
                offset: [-72, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[61, 169], [227, 75], [185, 54], [55, -148], [-201, 43]],
            },
        ],
    }, romanticTent1: {
        assets: [
            {
                id: IdAssetBundleBuildings.romanticTent_1,
                offset: [-6, -122],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 106], [157, 32], [6, -59], [-143, 32]],
            },
        ],
    }, rushingWaterfall1: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_1,
                offset: [-5, -68],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 76], [166, -5], [5, -89], [-158, -4]],
            },
        ],
    }, rushingWaterfall2: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_2,
                offset: [-7, -71],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[5, 76], [166, -5], [5, -89], [-158, -4]],
            },
        ],
    }, rushingWaterfall3: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_3,
                offset: [-17, -81],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[18, 79], [175, 2], [16, -86], [-139, 3]],
            },
        ],
    }, rushingWaterfall4: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_4,
                offset: [-10, -99],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[11, 100], [164, 24], [10, -67], [-141, 24]],
            },
        ],
    }, rushingWaterfall5: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_5,
                offset: [-17, -122],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[16, 125], [173, 41], [18, -42], [-143, 40]],
            },
        ],
    }, rushingWaterfall6: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_6,
                offset: [-8, -121],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[7, 124], [153, 51], [8, -51], [-134, 54]],
            },
        ],
    }, rushingWaterfall7: {
        assets: [
            {
                id: IdAssetBundleBuildings.rushingWaterfall_7,
                offset: [-9, -121],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[9, 123], [144, 55], [9, -50], [-131, 54]],
            },
        ],
    }, santasPostbox1: {
        assets: [
            {
                id: IdAssetBundleBuildings.santasPostbox_1,
                offset: [0, -51],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-8, 78], [80, 40], [28, -86], [-79, 38]],
            },
        ],
    }, santasSleigh1: {
        assets: [
            {
                id: IdAssetBundleBuildings.santasSleigh_1,
                offset: [-2, -38],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-7, 58], [77, 10], [8, -61], [-78, 11]],
            },
        ],
    }, sheepPen1: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_1,
                offset: [-62, -124],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_1_fence,
                offset: [-56, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-167, 7], [30, 109], [196, 26], [-8, -151]],
            },
        ],
    }, sheepPen2: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_2,
                offset: [-62, -133],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_2_fence,
                offset: [-57, -82],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-167, 7], [30, 109], [196, 26], [-8, -151]],
            },
        ],
    }, sheepPen3: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_3,
                offset: [-62, -127],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_3_fence,
                offset: [-56, -83],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-167, 7], [30, 109], [196, 26], [-8, -151]],
            },
        ],
    }, sheepPen4: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_4,
                offset: [-68, -133],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_4_fence,
                offset: [-57, -82],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-167, 7], [30, 109], [196, 26], [-8, -151]],
            },
        ],
    }, sheepPen5: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_5,
                offset: [-70, -160],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_5_fence,
                offset: [-58, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-167, 7], [30, 109], [196, 26], [-8, -151]],
            },
        ],
    }, sheepPen6: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_6,
                offset: [-69, -163],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_6_fence,
                offset: [-60, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-130, -58], [-173, 36], [29, 140], [197, 64], [114, -45], [-14, -140]],
            },
        ],
    }, sheepPen7: {
        assets: [
            {
                id: IdAssetBundleBuildings.sheepPen_7,
                offset: [-66, -157],
            },
            {
                id: IdAssetBundleBuildings.sheepPen_7_fence,
                offset: [-54, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-169, 39], [27, 138], [193, 51], [125, -31], [-11, -143], [-130, -66]],
            },
        ],
    }, silentLamb1: {
        assets: [
            {
                id: IdAssetBundleBuildings.silentLamb_1,
                offset: [-2, -42],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 59], [79, 22], [12, -65], [-84, 7]],
            },
        ],
    }, silo1: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_1,
                offset: [-56, -71],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-31, -41],
                    [-32, -58],
                    [13, -100],
                    [58, -53],
                    [57, 10],
                    [127, 48],
                    [56, 88],
                    [-111, 0],
                ],
            },
        ],
    }, silo2: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_2,
                offset: [-53, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-116, 5], [55, 93], [135, 54], [54, 11], [53, -55], [9, -99], [-36, -37]],
            },
        ],
    }, silo3: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_3,
                offset: [-55, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-32, -12],
                    [-122, 28],
                    [55, 110],
                    [137, 70],
                    [60, 26],
                    [59, -72],
                    [16, -120],
                    [-30, -76],
                ],
            },
        ],
    }, silo4: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_4,
                offset: [-55, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [57, 113],
                    [137, 70],
                    [58, 29],
                    [59, -76],
                    [15, -117],
                    [-31, -78],
                    [-29, -13],
                    [-117, 25],
                ],
            },
        ],
    }, silo5: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_5,
                offset: [-55, -95],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [18, -13],
                radius: 90,
            },
        ],
    }, silo6: {
        assets: [
            {
                id: IdAssetBundleBuildings.silo_6,
                offset: [-52, -97],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [12, -13],
                radius: 99,
            },
        ],
    }, simpleHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.simpleHouse_1,
                offset: [-2, -88],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-149, 12],
                    [3, 89],
                    [155, 12],
                    [70, -32],
                    [66, -64],
                    [-32, -106],
                    [-85, -34],
                ],
            },
        ],
    }, simpleHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.simpleHouse_2,
                offset: [1, -91],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-2, 110],
                    [171, 20],
                    [95, -19],
                    [95, -53],
                    [-37, -106],
                    [-85, -31],
                    [-165, 20],
                ],
            },
        ],
    }, simpleHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.simpleHouse_3,
                offset: [-4, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[3, 112], [175, 27], [101, -8], [99, -48], [-32, -103], [-150, 29]],
            },
        ],
    }, simpleHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.simpleHouse_4,
                offset: [-11, -124],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [10, 143],
                    [183, 51],
                    [85, 3],
                    [67, -40],
                    [64, -98],
                    [-25, -132],
                    [-72, -80],
                    [-72, -10],
                    [-157, 57],
                ],
            },
        ],
    }, simpleHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.simpleHouse_5,
                offset: [-11, -124],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 0],
                radius: 109,
            },
        ],
    }, sleighWithGifts1: {
        assets: [
            {
                id: IdAssetBundleBuildings.sleighWithGifts_1,
                offset: [-58, -44],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[30, 71], [97, 31], [-22, -28], [-81, 11]],
            },
        ],
    }, spookyWell1: {
        assets: [
            {
                id: IdAssetBundleBuildings.spookyWell_1,
                offset: [0, -55],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 69], [76, 24], [17, -78], [-20, -73], [-79, 26]],
            },
        ],
    }, springFountain1: {
        assets: [
            {
                id: IdAssetBundleBuildings.springFountain_1,
                offset: [0, -37],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-1, 69], [99, 17], [0, -72], [-99, 18]],
            },
        ],
    }, starSphere11: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere1_1,
                offset: [1, -74],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, starSphere21: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere2_1,
                offset: [-1, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, starSphere31: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere3_1,
                offset: [-2, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, starSphere41: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere4_1,
                offset: [-2, -79],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, starSphere51: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere5_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, starSphere61: {
        assets: [
            {
                id: IdAssetBundleBuildings.starSphere6_1,
                offset: [0, -97],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 92], [152, 18], [1, -67], [-161, 13]],
            },
        ],
    }, thicket1: {
        assets: [
            {
                id: IdAssetBundleBuildings.thicket_1,
                offset: [4, -126],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-3, 124], [154, 43], [-5, -43], [-158, 39]],
            },
        ],
    }, tiki11: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki1_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, tiki21: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki2_1,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, tiki31: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki3_1,
                offset: [-2, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[2, 98], [163, 11], [1, -72], [-163, 12]],
            },
        ],
    }, tiki41: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki4_1,
                offset: [-1, -93],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 95], [156, 9], [3, -67], [-160, 9]],
            },
        ],
    }, tiki51: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki5_1,
                offset: [-3, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 106], [166, 25], [5, -63], [-161, 25]],
            },
        ],
    }, tiki61: {
        assets: [
            {
                id: IdAssetBundleBuildings.tiki6_1,
                offset: [0, -120],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, 122], [165, 36], [1, -50], [-166, 41]],
            },
        ],
    }, treeNursery1: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_1,
                offset: [-53, -52],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 85], [151, 35], [-48, -65], [-147, -15]],
            },
        ],
    }, treeNursery2: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_2,
                offset: [-51, -54],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[50, 86], [152, 38], [-50, -63], [-147, -12]],
            },
        ],
    }, treeNursery3: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_3,
                offset: [-51, -54],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 88], [151, 37], [-50, -63], [-147, -13]],
            },
        ],
    }, treeNursery4: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_4,
                offset: [-51, -57],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 91], [150, 40], [-48, -60], [-147, -11]],
            },
        ],
    }, treeNursery5: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_5,
                offset: [-51, -57],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[51, 90], [151, 40], [-47, -60], [-147, -11]],
            },
        ],
    }, treeNursery6: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_6,
                offset: [-51, -64],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 97], [150, 47], [-49, -53], [-149, -3]],
            },
        ],
    }, treeNursery7: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_7,
                offset: [-53, -67],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 99], [152, 50], [-48, -50], [-146, -1]],
            },
        ],
    }, treeNursery8: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_8,
                offset: [-51, -78],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[51, 109], [151, 61], [-49, -39], [-148, 12]],
            },
        ],
    }, treeNursery9: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_9,
                offset: [-51, -87],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[52, 120], [150, 70], [-51, -30], [-149, 21]],
            },
        ],
    }, treeNursery10: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeNursery_10,
                offset: [-51, -86],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[48, 118], [151, 68], [-50, -34], [-145, 20]],
            },
        ],
    }, treeOfLanterns1: {
        assets: [
            {
                id: IdAssetBundleBuildings.treeOfLanterns_1,
                offset: [-4, -124],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 33],
                points: [
                    [12, 101],
                    [176, 14],
                    [148, -85],
                    [104, -48],
                    [108, -140],
                    [64, -142],
                    [61, -126],
                    [36, -135],
                    [6, -160],
                    [-22, -138],
                    [-54, -119],
                    [-74, -142],
                    [-103, -138],
                    [-91, -49],
                    [-150, -88],
                    [-156, 10],
                ],
            },
        ],
    }, tropicalChickenCoop1: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_1,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence1,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop2: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_2,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence2,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop3: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_3,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence3,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop4: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_4,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence4,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop5: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_5,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence5,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop6: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_6,
                offset: [-8, -85],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence6,
                offset: [-8, -60],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[0, -89], [163, -4], [-1, 80], [-162, -2]],
            },
        ],
    }, tropicalChickenCoop7: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_7,
                offset: [-5, -123],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence7,
                offset: [0, -63],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-87, -66], [6, -103], [129, 42], [5, 108], [-122, 44]],
            },
        ],
    }, tropicalChickenCoop8: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_8,
                offset: [-5, -123],
            },
            {
                id: IdAssetBundleBuildings.tropicalChickenCoop_fence8,
                offset: [0, -63],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-87, -66], [6, -103], [129, 42], [5, 108], [-122, 44]],
            },
        ],
    }, tropicalCowBarn1: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_1,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn2: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_2,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn3: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_3,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn4: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_4,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn5: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_5,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn6: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_6,
                offset: [-61, -123],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [87, -32], [82, -135], [-67, -151], [-198, -6]],
            },
        ],
    }, tropicalCowBarn7: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalCowBarn_7,
                offset: [-61, -134],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[58, 124], [222, 40], [108, -135], [-162, -147], [-198, -6]],
            },
        ],
    }, tropicalHouse1: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalHouse_1,
                offset: [12, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-149, 12], [3, 89], [147, 26], [66, -64], [-55, -105]],
            },
        ],
    }, tropicalHouse2: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalHouse_2,
                offset: [12, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-144, 5], [-12, 102], [147, 26], [100, -44], [-48, -114]],
            },
        ],
    }, tropicalHouse3: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalHouse_3,
                offset: [9, -117],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-121, 43], [10, 112], [156, 27], [151, -65], [-3, -111], [-171, -102]],
            },
        ],
    }, tropicalHouse4: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalHouse_4,
                offset: [2, -152],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-166, -59], [-114, 73], [7, 139], [161, 67], [145, -47], [-15, -145]],
            },
        ],
    }, tropicalHouse5: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalHouse_5,
                offset: [2, -152],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [-4, 23],
                radius: 143,
            },
        ],
    }, tropicalPigPen1: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_1,
                offset: [-61, -138],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence1,
                offset: [-43, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [40, 123],
                    [206, 44],
                    [109, -17],
                    [121, -142],
                    [-16, -144],
                    [-171, -92],
                    [-144, 22],
                ],
            },
        ],
    }, tropicalPigPen2: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_2,
                offset: [-61, -138],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence2,
                offset: [-43, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 123], [206, 44], [184, -110], [-16, -144], [-172, -105], [-144, 22]],
            },
        ],
    }, tropicalPigPen3: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_3,
                offset: [-61, -138],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence3,
                offset: [-43, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[40, 123], [206, 44], [184, -118], [-16, -144], [-171, -92], [-144, 22]],
            },
        ],
    }, tropicalPigPen4: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_4,
                offset: [-65, -165],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence4,
                offset: [-70, -77],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [43, 143],
                    [190, 63],
                    [182, -81],
                    [-102, -179],
                    [-166, -168],
                    [-171, -92],
                    [-139, 42],
                ],
            },
        ],
    }, tropicalPigPen5: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_5,
                offset: [-62, -170],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence5,
                offset: [-64, -74],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-146, 56], [42, 154], [202, 85], [187, -74], [3, -179], [-165, -164]],
            },
        ],
    }, tropicalPigPen6: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_6,
                offset: [-61, -173],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence6,
                offset: [-38, -83],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-136, 59],
                    [40, 149],
                    [196, 81],
                    [181, -126],
                    [51, -181],
                    [-169, -171],
                    [-185, -76],
                ],
            },
        ],
    }, tropicalPigPen7: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_7,
                offset: [-64, -176],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence7,
                offset: [-73, -92],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-136, 59], [40, 149], [196, 81], [51, -181], [-169, -171]],
            },
        ],
    }, tropicalPigPen8: {
        assets: [
            {
                id: IdAssetBundleBuildings.tropicalPigPen_8,
                offset: [-64, -176],
            },
            {
                id: IdAssetBundleBuildings.tropicalPigPen_fence8,
                offset: [-73, -92],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-136, 59], [40, 149], [196, 81], [51, -181], [-169, -171]],
            },
        ],
    }, twinklingSnowman1: {
        assets: [
            {
                id: IdAssetBundleBuildings.twinklingSnowman_1,
                offset: [-3, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[9, 63], [83, 20], [-2, -70], [-77, 22]],
            },
        ],
    }, unicornStatue1: {
        assets: [
            {
                id: IdAssetBundleBuildings.unicornStatue_1,
                offset: [-54, -48],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[38, 46], [113, 13], [-21, -56], [-89, -24]],
            },
        ],
    }, uniqueWindmill1: {
        assets: [
            {
                id: IdAssetBundleBuildings.uniqueWindmill_1,
                offset: [-48, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [47, 98],
                    [123, 60],
                    [47, 21],
                    [19, -64],
                    [-5, -9],
                    [-39, -25],
                    [-117, 15],
                ],
            },
        ],
    }, upgradableStarSphere1: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_1,
                offset: [1, -74],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, upgradableStarSphere2: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_2,
                offset: [-1, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, upgradableStarSphere3: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_3,
                offset: [-2, -73],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, upgradableStarSphere4: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_4,
                offset: [-2, -79],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, upgradableStarSphere5: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_5,
                offset: [1, -84],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [151, 4], [-1, -81], [-154, -1]],
            },
        ],
    }, upgradableStarSphere6: {
        assets: [
            {
                id: IdAssetBundleBuildings.upgradableStarSphere_6,
                offset: [0, -97],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 92], [152, 18], [1, -67], [-161, 13]],
            },
        ],
    }, vegetablePatch1: {
        assets: [
            {
                id: IdAssetBundleBuildings.vegetablePatch_1,
                offset: [-46, -45],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[45, 63], [129, 20], [-43, -66], [-123, -20]],
            },
        ],
    }, weddingPavilion1: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_1,
                offset: [-6, -98],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, weddingPavilion2: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_2,
                offset: [1, -94],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 81], [165, -2], [7, -86], [-154, -1]],
            },
        ],
    }, weddingPavilion3: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_3,
                offset: [-4, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 86], [158, 8], [-3, -75], [-155, 7]],
            },
        ],
    }, weddingPavilion4: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_4,
                offset: [-6, -137],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[6, 95], [161, 13], [4, -73], [-161, 13]],
            },
        ],
    }, weddingPavilion5: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_5,
                offset: [-8, -145],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 99], [155, 22], [4, -65], [-148, 23]],
            },
        ],
    }, weddingPavilion6: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_6,
                offset: [3, -162],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[-2, 106], [151, 28], [-3, -62], [-154, 30]],
            },
        ],
    }, weddingPavilion7: {
        assets: [
            {
                id: IdAssetBundleBuildings.weddingPavilion_7,
                offset: [-3, -164],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[1, 110], [151, 35], [-2, -57], [-151, 35]],
            },
        ],
    }, well1: {
        assets: [
            {
                id: IdAssetBundleBuildings.well_1,
                offset: [-50, -70],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [[41, 75], [115, 38], [-34, -38], [-112, -2]],
            },
        ],
    }, wellspringOfCharity1: {
        assets: [
            {
                id: IdAssetBundleBuildings.wellspringOfCharity_1,
                offset: [-3, -128],
            },
        ],
        colliders: [
            {
                type: 0,
                offset: [1, -46],
                size: [3, -6],
            },
            {
                type: 1,
                offset: [3, 28],
                radius: 90,
            },
        ],
    }, wellspringOfCharity2: {
        assets: [
            {
                id: IdAssetBundleBuildings.wellspringOfCharity_2,
                offset: [-1, -120],
            },
        ],
        colliders: [
            {
                type: 0,
                offset: [-2, -46],
                size: [3, -6],
            },
            {
                type: 1,
                offset: [3, 12],
                radius: 106,
            },
        ],
    }, wellspringOfCharity3: {
        assets: [
            {
                id: IdAssetBundleBuildings.wellspringOfCharity_3,
                offset: [-1, -125],
            },
        ],
        colliders: [
            {
                type: 0,
                offset: [-2, -46],
                size: [3, -6],
            },
            {
                type: 1,
                offset: [3, 12],
                radius: 106,
            },
        ],
    }, westernWindmill1: {
        assets: [
            {
                id: IdAssetBundleBuildings.westernWindmill_1,
                offset: [-48, -85],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [47, 98],
                    [123, 60],
                    [47, 21],
                    [19, -64],
                    [-5, -9],
                    [-39, -25],
                    [-117, 15],
                ],
            },
        ],
    }, windmill1: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.windmill_1,
                offset: [3, -105],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 0],
                radius: 118,
            },
        ],
    }, windmill2: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_2,
                offset: [-8, -108],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [8, 122],
                    [168, 37],
                    [86, 4],
                    [64, -65],
                    [-48, -123],
                    [-87, -83],
                    [-89, -7],
                    [-155, 38],
                ],
            },
        ],
    }, windmill3: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_3,
                offset: [-9, -128],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [9, 145],
                    [172, 57],
                    [78, 0],
                    [70, -76],
                    [-78, -112],
                    [-88, 12],
                    [-163, 61],
                ],
            },
        ],
    }, windmill4: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_4,
                offset: [0, -135],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [1, 151],
                    [170, 67],
                    [65, -3],
                    [69, -72],
                    [-68, -138],
                    [-94, -15],
                    [-110, 26],
                    [-163, 69],
                ],
            },
        ],
    }, windmill5: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_5,
                offset: [5, -154],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-6, 173],
                    [166, 88],
                    [79, 41],
                    [65, 7],
                    [66, -88],
                    [-65, -156],
                    [-100, 4],
                    [-117, 44],
                    [-174, 85],
                ],
            },
        ],
    }, windmill6: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_6,
                offset: [5, -154],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-6, 173],
                    [166, 88],
                    [79, 41],
                    [65, 7],
                    [66, -88],
                    [-65, -156],
                    [-100, 4],
                    [-117, 44],
                    [-174, 85],
                ],
            },
        ],
    }, windmill7: {
        assets: [
            {
                id: IdAssetBundleBuildings.windmill_7,
                offset: [5, -154],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-6, 173],
                    [166, 88],
                    [79, 41],
                    [65, 7],
                    [66, -88],
                    [-65, -156],
                    [-100, 4],
                    [-117, 44],
                    [-174, 85],
                ],
            },
        ],
    }, winterWonder1: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_1,
                offset: [-1, -100],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 32],
                radius: 133,
            },
        ],
    }, winterWonder2: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_2,
                offset: [-1, -95],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 25],
                radius: 136,
            },
        ],
    }, winterWonder3: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_3,
                offset: [-1, -106],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, winterWonder4: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_4,
                offset: [-1, -104],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, winterWonder5: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_5,
                offset: [-1, -102],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, winterWonder6: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_6,
                offset: [-1, -106],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, winterWonder7: {
        assets: [
            {
                id: IdAssetBundleBuildings.winterWonder_7,
                offset: [-1, -130],
            },
        ],
        colliders: [
            {
                type: 1,
                offset: [0, 29],
                radius: 140,
            },
        ],
    }, ScaffoldingCelebration3x3: {
        assets: [
            {
                id: IdAssetBundleBuildings.celebration_3x3,
                offset: [8, -95],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [-4, 108],
                    [71, 71],
                    [60, 62],
                    [60, -60],
                    [7, -100],
                    [-48, -59],
                    [-46, 48],
                    [-83, 66],
                ],
            },
        ],
    }, ScaffoldingCelebration3x6: {
        assets: [
            {
                id: IdAssetBundleBuildings.celebration_3x6,
                offset: [-53, -113],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [47, 121],
                    [123, 83],
                    [102, 73],
                    [102, -47],
                    [93, -79],
                    [-34, -141],
                    [-82, -122],
                    [-89, 20],
                    [-124, 36],
                ],
            },
        ],
    }, ScaffoldingCelebration6x6: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.celebration_6x6,
                offset: [-4, -151],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [145, 58],
                    [164, 67],
                    [-9, 150],
                    [-168, 72],
                    [-134, 54],
                    [-132, -73],
                    [7, -133],
                    [145, -63],
                ],
            },
        ],
    }, ScaffoldingCelebration6x9: {
        assets: [
            {
                id: IdAssetBundleBuildings.celebration_6x9,
                offset: [-62, -171],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [197, 71],
                    [210, 82],
                    [44, 164],
                    [-206, 39],
                    [-169, 18],
                    [-164, -89],
                    [-24, -157],
                    [189, -80],
                ],
            },
        ],
    }, ScaffoldingCelebration9x9: {
        assets: [
            {
                id: IdAssetBundleBuildings.celebration_9x9,
                offset: [-8, -199],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [5, 178],
                    [-246, 60],
                    [-211, 42],
                    [-209, -67],
                    [16, -177],
                    [234, -71],
                    [248, 59],
                ],
            },
        ],
    }, Scaffolding3x3: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.scaffolding_3x3,
                offset: [5, -83],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [3, 102],
                    [82, 61],
                    [62, 47],
                    [62, -57],
                    [10, -84],
                    [-44, -58],
                    [-45, 36],
                    [-82, 56],
                ],
            },
        ],
    }, Scaffolding3x6: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.scaffolding_3x6,
                offset: [-52, -112],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [44, 125],
                    [126, 82],
                    [97, 68],
                    [98, -38],
                    [-38, -105],
                    [-92, -78],
                    [-92, 17],
                    [-132, 38],
                ],
            },
        ],
    }, Scaffolding6x6: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.scaffolding_6x6,
                offset: [-6, -148],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [146, 78],
                    [2, 152],
                    [-167, 69],
                    [-131, 50],
                    [-131, -47],
                    [9, -116],
                    [146, -48],
                ],
            },
        ],
    }, Scaffolding6x9: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.scaffolding_6x9,
                offset: [-70, -166],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [198, 100],
                    [58, 172],
                    [-202, 35],
                    [-166, 18],
                    [-165, -82],
                    [-23, -150],
                    [197, -40],
                ],
            },
        ],
    }, Scaffolding9x9: {
        assets: [
            {
                id: IdAssetBundleBuildingsInitial.scaffolding_9x9,
                offset: [-13, -197],
            },
        ],
        colliders: [
            {
                type: 2,
                offset: [0, 0],
                points: [
                    [14, 195],
                    [-250, 64],
                    [-205, 40],
                    [-205, -57],
                    [20, -168],
                    [240, -58],
                    [241, 44],
                    [271, 62],
                ],
            },
        ],
    } }, artConfigBuildingsOverrides);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/artConfigBuildings.ts
// module id = 85
// module chunks = 3